import { SvgIcon } from '@mui/material';

const DPDClassic = props => (
  <SvgIcon
    width='40.526'
    height='24.188'
    viewBox='0 0 40.526 24.188'
    {...props}
  >
    <g id='Group_164' data-name='Group 164' transform='translate(0 0)'>
      <g id='Group_143' data-name='Group 143' transform='translate(0 0)'>
        <path
          id='Path_45'
          data-name='Path 45'
          d='M36.705,7.332V9.995a1.435,1.435,0,0,0,1.433,1.433h8.209L42.439,5.9h-4.3a1.435,1.435,0,0,0-1.433,1.433'
          transform='translate(-8.742 -1.405)'
          fill='#db0032'
        />
        <path
          id='Path_46'
          data-name='Path 46'
          d='M39.849,13.2l-1.4-1.982a2.676,2.676,0,0,1-.584.066H29.4A2.7,2.7,0,0,1,26.7,8.589V5.927A2.7,2.7,0,0,1,29.4,3.234h3.411L31.065.77A2.467,2.467,0,0,0,29.274,0H2.469A2.469,2.469,0,0,0,0,2.469v16.19a2.469,2.469,0,0,0,2.469,2.469H5.835a4.319,4.319,0,1,1,8.638,0H25.851a4.319,4.319,0,1,1,8.638,0h3.569a2.469,2.469,0,0,0,2.468-2.469V14.9a2.471,2.471,0,0,0-.677-1.7M14.1,13.723a.318.318,0,0,1-.161.039.326.326,0,0,1-.161-.039L9.651,11.287a.359.359,0,0,1-.161-.28V6.435L13.5,8.769a.1.1,0,0,1,.041.068v3.446a.156.156,0,0,0,.076.126l.245.136a.159.159,0,0,0,.078.017h0a.162.162,0,0,0,.073-.017l.245-.136a.158.158,0,0,0,.077-.126V8.417a.155.155,0,0,0-.074-.127L9.715,5.64l4.063-2.214a.343.343,0,0,1,.163-.037.35.35,0,0,1,.163.037L18.166,5.64l-2.9,1.687a.155.155,0,0,0-.071.13l.006.281a.148.148,0,0,0,.025.075l0,0a.148.148,0,0,0,.051.055l.241.143a.158.158,0,0,0,.149,0l2.717-1.584v4.572a.359.359,0,0,1-.16.28ZM24.022,18.7H16.8a.63.63,0,0,1,0-1.26h7.222a.63.63,0,0,1,0,1.26'
          transform='translate(0 0)'
          fill='#db0032'
        />
        <path
          id='Path_47'
          data-name='Path 47'
          d='M15.191,25.587a3.068,3.068,0,0,0-.873-1.17,3.048,3.048,0,0,0-.824-.486,3.062,3.062,0,0,0-3.94,1.656,2.943,2.943,0,0,0-.1.281A3.062,3.062,0,0,0,11.182,29.6a2.985,2.985,0,0,0,.574.178,2.867,2.867,0,0,0,.3.046,3.064,3.064,0,0,0,.625,0,2.867,2.867,0,0,0,.3-.046,2.976,2.976,0,0,0,.574-.178,3.057,3.057,0,0,0,.755-.458,3.093,3.093,0,0,0,.415-.414,3.063,3.063,0,0,0,.561-2.856,2.943,2.943,0,0,0-.1-.281'
          transform='translate(-2.218 -5.649)'
          fill='#db0032'
        />
        <path
          id='Path_48'
          data-name='Path 48'
          d='M11.765,31.434a2.976,2.976,0,0,0,.574.178'
          transform='translate(-2.802 -7.487)'
          fill='#db0032'
        />
        <path
          id='Path_49'
          data-name='Path 49'
          d='M14.8,24a3.146,3.146,0,0,1,.337.157'
          transform='translate(-3.525 -5.715)'
          fill='#db0032'
        />
        <path
          id='Path_50'
          data-name='Path 50'
          d='M11.751,24a3.146,3.146,0,0,0-.337.157'
          transform='translate(-2.719 -5.715)'
          fill='#db0032'
        />
        <path
          id='Path_51'
          data-name='Path 51'
          d='M17.164,26.54a3.064,3.064,0,0,1,.138.91'
          transform='translate(-4.088 -6.321)'
          fill='#db0032'
        />
        <path
          id='Path_52'
          data-name='Path 52'
          d='M9.45,26.54a3.064,3.064,0,0,0-.138.91'
          transform='translate(-2.218 -6.321)'
          fill='#db0032'
        />
        <path
          id='Path_53'
          data-name='Path 53'
          d='M10.087,25.179a3.034,3.034,0,0,0-.458.755'
          transform='translate(-2.293 -5.997)'
          fill='#db0032'
        />
        <path
          id='Path_54'
          data-name='Path 54'
          d='M16.427,25.179a3.034,3.034,0,0,1,.458.755'
          transform='translate(-3.913 -5.997)'
          fill='#db0032'
        />
        <path
          id='Path_55'
          data-name='Path 55'
          d='M41.465,25.587a3.068,3.068,0,0,0-.873-1.17,3.048,3.048,0,0,0-.824-.486,3.053,3.053,0,0,0-2.58.157c-.087.047-.171.1-.252.153a3.079,3.079,0,0,0-.651.591,3.033,3.033,0,0,0-.458.755,2.942,2.942,0,0,0-.1.281,3.059,3.059,0,0,0,1.211,3.446c.081.055.165.106.252.153a3.013,3.013,0,0,0,.841.307,2.867,2.867,0,0,0,.3.046,3.064,3.064,0,0,0,.625,0,2.867,2.867,0,0,0,.3-.046,2.976,2.976,0,0,0,.574-.178,3.057,3.057,0,0,0,.755-.458,3.093,3.093,0,0,0,.415-.414,3.063,3.063,0,0,0,.561-2.856,2.943,2.943,0,0,0-.1-.281'
          transform='translate(-8.476 -5.649)'
          fill='#db0032'
        />
        <path
          id='Path_56'
          data-name='Path 56'
          d='M38.53,31.572a3.051,3.051,0,0,1-.842-.307'
          transform='translate(-8.977 -7.447)'
          fill='#db0032'
        />
        <path
          id='Path_57'
          data-name='Path 57'
          d='M37.01,30.643A3.07,3.07,0,0,1,35.9,29.3'
          transform='translate(-8.551 -6.978)'
          fill='#db0032'
        />
        <path
          id='Path_58'
          data-name='Path 58'
          d='M36.361,25.179a3.048,3.048,0,0,0-.458.755'
          transform='translate(-8.551 -5.997)'
          fill='#db0032'
        />
        <path
          id='Path_59'
          data-name='Path 59'
          d='M35.724,26.54a3.064,3.064,0,0,0-.138.91'
          transform='translate(-8.476 -6.321)'
          fill='#db0032'
        />
        <path
          id='Path_60'
          data-name='Path 60'
          d='M41.075,24a3.146,3.146,0,0,1,.337.157'
          transform='translate(-9.783 -5.715)'
          fill='#db0032'
        />
        <path
          id='Path_61'
          data-name='Path 61'
          d='M38.025,24a3.146,3.146,0,0,0-.337.157'
          transform='translate(-8.977 -5.715)'
          fill='#db0032'
        />
        <path
          id='Path_62'
          data-name='Path 62'
          d='M43.438,26.54a3.064,3.064,0,0,1,.138.91'
          transform='translate(-10.346 -6.321)'
          fill='#db0032'
        />
        <path
          id='Path_63'
          data-name='Path 63'
          d='M42.7,25.179a3.034,3.034,0,0,1,.458.755'
          transform='translate(-10.171 -5.997)'
          fill='#db0032'
        />
      </g>
    </g>
  </SvgIcon>
);

export default DPDClassic;
